
import React, { useEffect } from 'react'

import { Box, Grid, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import { Barcode } from 'src/components/Barcode'

import { convertGS1 } from './utils'

const useStyles = makeStyles({
  label: {
    width: '4in',
    height: '6in',
  },
  zoneA: {
    borderRight: '1px solid black',
    borderBottom: '1px solid black',
    height: '1in',
    width: '2in',
    fontSize: '14px',
  },
  zoneB: {
    borderLeft: '1px solid black',
    borderBottom: '1px solid black',
    height: '1in',
    width: '2in',
    fontSize: '14px',
  },
  zoneC: {
    borderTop: '1px solid black',
    borderRight: '1px solid black',
    borderBottom: '1px solid black',
    height: '1in',
    width: '2in',
  },
  zoneD: {
    borderTop: '1px solid black',
    borderLeft: '1px solid black',
    borderBottom: '1px solid black',
    height: '1in',
    width: '2in',
  },
  zoneE: {
    borderTop: '1px solid black',
    borderBottom: '1px solid black',
    height: '1in',
    width: '4in',
  },
  zoneF: {
    borderTop: '1px solid black',
    borderBottom: '1px solid black',
    height: '1in',
    width: '4in',
  },
  zoneG: {
    borderTop: '1px solid black',
    height: '1in',
    width: '4in',
  },
  header: {
    fontSize: '12px',
    fontWeight: 'bold',
    paddingLeft: '3px',
  },
  poNumber: {
    fontWeight: 'bold',
  },
  address: {
    lineHeight: '1.0',
    paddingLeft: '10px',
  },
  from: {
    lineHeight: '1.0',
    paddingLeft: '5px',
  },
  carrier: {
    fontWeight: 'bold',
    paddingLeft: '5px',
  },
  to: {
    lineHeight: '1.0',
    fontSize: '16px',
    paddingLeft: '10px',
  },
  container: {
    top: 'auto',
    bottom: 0,
  },
  center: {
    flexGrow: 1,
    textAlign: 'center',
  },
  inlineHeader: {
    fontWeight: 'bold',
    fontSize: '14px',
    paddingLeft: '3px',
  },
})

interface TargetLabelProps {
  zoneA: string[]
  zoneB: string[]
  zoneC: string
  zoneE: string
  zoneG: string
}

interface Props {
  data: TargetLabelProps
  onReadyToPrint?: () => void
}

export const TargetLabel = (props: Props) => {
  const { data, onReadyToPrint } = props
  const shipToBarcode = { barcode: convertGS1(data.zoneC, 3), type: 'gs1-128', displayName: '' }
  const ssccBarcode = { barcode: convertGS1(data.zoneG, 2), type: 'gs1-128', displayName: '' }
  const classes = useStyles()

  useEffect(() => {
    onReadyToPrint?.()
  }, [onReadyToPrint])

  return (
    <div className={`always-page-break ${classes.label}`}>
      <div className="print-page">
        <Box className={classes.label}>
          <Grid container spacing={0}>
            <Grid item>
              <Box className={classes.zoneA}>
                <Typography className={classes.header}>FROM</Typography>
                {data.zoneA.map((line) => (
                  <Typography key={line} className={classes.from}>
                    {line}
                  </Typography>
                ))}
              </Box>
            </Grid>
            <Grid item>
              <Box className={classes.zoneB}>
                <Typography className={classes.header}>TO</Typography>
                {data.zoneB.map((line) => (
                  <Typography key={line} className={classes.to}>
                    {line}
                  </Typography>
                ))}
              </Box>
            </Grid>
            <Grid item>
              <Box className={classes.zoneC}>
                <Grid item xs={12}>
                  <Typography className={classes.header}>SHIP TO POSTAL CODE</Typography>
                </Grid>
                <Box display="flex" justifyContent="center">
                  <Typography variant="h6">{shipToBarcode.barcode}</Typography>
                </Box>
                <Box ml={6} mr={6}>
                  <Barcode barcode={shipToBarcode} scale={2} height={9} />
                </Box>
              </Box>
            </Grid>
            <Grid item>
              <Box className={classes.zoneD}>
              </Box>
            </Grid>
            <Grid item>
              <Box className={classes.zoneE} pt={1} pl={1}>
                <Typography>PO#: <span className={classes.poNumber}>{data.zoneE}</span></Typography>
              </Box>
            </Grid>
            <Grid item>
              <Box className={classes.zoneF}>
              </Box>
            </Grid>
            <Grid item>
              <Box className={`${classes.zoneG} ${classes.container}`}>
                <Typography className={classes.header}>SSCC-18</Typography>
                <Box ml={5} mr={5}>
                  <Barcode barcode={ssccBarcode} scale={2} height={20} />
                </Box>
                <Box display="flex" justifyContent="center">
                  <Typography variant="h4">{ssccBarcode.barcode}</Typography>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </div>
    </div>
  )
}
